import { getCanonicalCitySlug } from "../config/cityData";

const normalizeSegment = (value?: string | null): string | null => {
  if (!value) return null;
  const trimmed = value.trim();
  return trimmed.length ? trimmed : null;
};

const encodeSegment = (value?: string | null): string => encodeURIComponent(value ?? "");

const toCitySlug = (city?: string | null): string | null => {
  const normalized = normalizeSegment(city);
  if (!normalized) return null;
  return getCanonicalCitySlug(normalized);
};

const toAreaSlug = (area?: string | null): string | null => {
  const normalized = normalizeSegment(area);
  if (!normalized) return null;
  return normalized
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/-+/g, "-");
};

export const normalizeAreaForMatch = (area?: string | null): string =>
  toAreaSlug(area) || "";

export const areaNameToSlug = (area?: string | null): string | null =>
  toAreaSlug(area);

export const getAreaFromPath = (path?: string): string | null => {
  if (!path) return null;
  const pathname = path.split("?")[0];
  const parts = pathname.split("/").filter(Boolean);
  if (parts.length < 3 || parts[1]?.toLowerCase() !== "area") {
    return null;
  }
  try {
    return decodeURIComponent(parts[2]);
  } catch {
    return parts[2];
  }
};

export const buildTurfDetailRoute = ({
  city,
  userName,
  pitchName,
  areaName,
}: {
  city: string;
  userName: string;
  pitchName: string;
  areaName?: string | null;
}): string => {
  const citySlug = toCitySlug(city);
  const normalizedArea = toAreaSlug(areaName);

  if (!citySlug) return "/";

  if (normalizedArea) {
    return `/${encodeSegment(citySlug)}/area/${encodeSegment(normalizedArea)}/${encodeSegment(userName)}/${encodeSegment(pitchName)}`;
  }

  return `/${encodeSegment(citySlug)}/${encodeSegment(userName)}/${encodeSegment(pitchName)}`;
};

export const buildTurfBookingRoute = ({
  city,
  userName,
  pitchName,
  areaName,
}: {
  city: string;
  userName: string;
  pitchName: string;
  areaName?: string | null;
}): string => `${buildTurfDetailRoute({ city, userName, pitchName, areaName })}/booking`;
